import React, { useEffect, useState } from 'react';

const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('theme') : null;
    return saved || 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('theme', theme); } catch {}
  }, [theme]);

  const next = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      aria-label="Toggle color theme"
      title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => setTheme(next)}
      style={{
        border: '1px solid var(--accent-color)',
        color: 'var(--accent-color)',
        background: 'transparent',
        padding: '6px 10px',
        borderRadius: 6,
        cursor: 'pointer',
        fontFamily: 'Orbitron, sans-serif'
      }}
    >
      {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
    </button>
  );
};

export default ThemeToggle;

